import {useAppSelector} from "../../../redux/hooks";
import {MutableRefObject, useCallback} from "react";
import {
  getMySongsPageTypeFilterMenuTitle
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore,} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {useDivRef} from "../../../components/common/hooks/useDivRef";
import {useOnClickOutside} from "../../../components/common/hooks/useOnOutsideClick";
import {MySongsPageMenuType} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.types";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterFeaturesDropdownMenuLogic {
  label: string;
  onClickMenuToggleHandler: () => void;
  isActive?: boolean;
  isAvailable?: boolean;
  dropdownFilterMenuRef: MutableRefObject<HTMLDivElement>;
}

const menuName: MySongsPageMenuType = `desktop.features`;

export const useFilterFeaturesDropdownMenuLogic = (): IFilterFeaturesDropdownMenuLogic => {
  const isActive = useAppSelector(() => mySongsPageStore.isMenuActive(menuName));
  const isAvailable = useAppSelector(mySongsFiltersStore.isFeaturesAvailable);
  const menuLabel = useAppSelector(getMySongsPageTypeFilterMenuTitle);

  const onClickOutsideMenuCloseHandler = useCallback(() => {
    if (!isActive) {
      // not active, no reason to close
      return;
    }
    mySongsPageStore.removeActiveMenu(menuName);
  }, [isActive]);

  const dropdownFilterMenuRef = useDivRef();
  useOnClickOutside<HTMLDivElement>(dropdownFilterMenuRef, onClickOutsideMenuCloseHandler);

  return {
    isAvailable,
    isActive,
    onClickMenuToggleHandler: () => mySongsPageStore.toggleSingleActiveMenu(menuName),
    label: menuLabel,
    dropdownFilterMenuRef,
  };
}
